<template>
  <div>
    <div class="switchModule">
      <textswitch
        style="width: 80%; height: 30px; border: 2px solid"
        @switchFunction="switchChangeFun"
        switchType="text"
        defaultColor="#FFFFFF"
        :highColor="Switch.switchColor"
        :defaultValue="Switch.switchDefaultValue"
        :switchList="Switch.switchListText"
        :itemIndex="0"
      ></textswitch>
    </div>

    <Search
      v-model="searchValue"
      shape="round"
      :placeholder="searchPlaceholder"
      type="digit"
      left-icon
      maxlength="11"
      style=""
    >
      <template #right-icon>
        <Button
          @click="queryOrderInfo"
          size="small"
          type="primary"
          round
          color="#292827"
          style="font-size: 16px"
        >
          查询
        </Button>
      </template>
    </Search>

    <inputCodeComVue v-model:show="show" />
    <Tabs v-model:active="tabActive" animated>
      <Tab name="1">
        <CellGroup inset class="contentStyle">
          <!-- 课群信息 -->
          <groupDetailsCom />
          <!-- 订单信息 -->
          <orderDetailsCom />
          <!-- 支付信息 -->
          <payDetailsCom />
          <!-- 基本信息 -->
          <userInfoDetailsCom />
          <!-- 考试信息 -->
          <examDetailsCom />
          <!-- 其他信息 -->
          <otherDetailsCom />

          <Field>
            <template #input>
              <Button
                size="small"
                type="success"
                color="linear-gradient(to right, #ff6034, #ee0a24)"
                round
                block
                @click="deleteOrder"
                >删除订单</Button
              >
            </template>
          </Field>
        </CellGroup>
      </Tab>
      <Tab name="2">
        <CellGroup inset class="contentStyle">
          <inviteDetailsComVue />
        </CellGroup>
      </Tab>
    </Tabs>
  </div>
</template>
<script setup>
import { ref, computed } from "vue";
import { Search, Button, CellGroup, Field, Notify, Tab, Tabs } from "vant";
import { payService } from "@/service/payService";
import { useOrder } from "@/composables/useOrder";
// 页面组件
import groupDetailsCom from "./components/groupDetailsCom.vue";
import orderDetailsCom from "./components/orderDetailsCom.vue";
import payDetailsCom from "./components/payDetailsCom.vue";
import userInfoDetailsCom from "./components/userInfoDetailsCom.vue";
import examDetailsCom from "./components/examDetailsCom.vue";
import otherDetailsCom from "./components/otherDetailsCom.vue";
import inputCodeComVue from "./components/inputCodeCom.vue";
import inviteDetailsComVue from "./components/inviteDetailsCom.vue";
import textswitch from "@/components/switch.vue";

import { inviteService } from "@/service/inviteService";
import { useInvite } from "@/composables/useInvite";
import { useData } from "@/composables/useData.js";
const { inviteData } = useInvite();
const { orderData } = useOrder();
const { sitedData } = useData();
// 用户点击开始时间
const searchValue = ref("");
const show = ref(false);
const tabActive = ref("0");
const Switch = ref({
  switchDefaultValue: 0,
  switchColor: "#292827",
  switchListText: [
    {
      title: "订单操作",
      value: 0,
    },
    {
      title: "邀请操作",
      value: 1,
    },
  ],
});

const searchPlaceholder = computed(() => {
  return tabActive.value == "1" ? "请输入订单ID" : "请输入邀请人手机号";
});

const switchChangeFun = (e) => {
  if (e.swithcSelectItem.value == 0) {
    tabActive.value = "1";
  } else {
    tabActive.value = "2";
  }
  Switch.value.switchDefaultValue = e.swithcSelectItem.value;
};
// 查询订单信息
const queryOrderInfo = () => {
  let AuthorizationCode = sessionStorage.getItem("AuthorizationCode");
  if (!AuthorizationCode) {
    show.value = true;
    return;
  }
  sitedData.value.order.orderID = searchValue.value;
  if (tabActive.value == "1") {
    payService
      .query(sitedData.value.order.orderID, 1, AuthorizationCode)
      .then((res) => {
        if (res.state != "success") {
          throw res.result;
        }
        orderData.value = res.result;
        Notify({ type: "success", message: "查询成功" });
      })
      .catch((errRes) => {
        Notify(errRes);
      });
  } else {
    inviteService.getInviteList(searchValue.value, "1").then((res) => {
      if (res["state"] == "success") {
        inviteData.value.cash = res["result"]["cash"];
        inviteData.value.cashAvailable = res["result"]["cashAvailable"];
        inviteData.value.Total = res["result"]["recordsTotal"];
        inviteData.value.inviteCode = res["result"]["inviteCode"];
        inviteData.value.phone = searchValue.value;
      } else {
        Notify(res["result"]);
      }
    });
  }
};

const deleteOrder = () => {
  Notify("暂未开发～");
};
</script>

<style>
.van-search__content {
  align-items: center;
  border: 2px solid #292827;
  padding-left: 18px;
}
.content {
  margin-bottom: 0 !important;
}
.van-search {
  padding-top: 0;
}
.van-tabs__wrap {
  display: none;
}
</style>
<style scoped>
.van-button--small {
  padding: 0 20px;
}

.CountDownBox {
  padding: 24px 0;
}

.CountDown {
  font-size: 58px;
  color: #676c67;
}

.switchModule {
  display: flex;
  align-items: center;
  height: 50px;
  justify-content: center;
  background: #fff;
}
.contentStyle {
  margin-top: 14px;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border: 1px solid #292827;
}
</style>
